export const IDENTIFICATION_TYPE_OPTIONS = [
  {
    value: "international_passport",
    description: "International Passport",
  },
  {
    value: "national_id",
    description: "National ID",
  },
  {
    value: "voters_card",
    description: "Voters Card",
  },
];

export const HAS_PEN_OPTIONS = [
  {
    value: "yes",
    description: "Yes",
  },
  {
    value: "no",
    description: "No",
  },
];

export const WILL_CONTRIBUTE_NHF_OPTIONS = [
  {
    value: "yes",
    description: "Yes",
  },
  {
    value: "no",
    description: "No",
  },
];

export const MARITAL_STATUS_OPTIONS = [
  {
    value: "single",
    description: "Single",
  },
  {
    value: "married",
    description: "Married",
  },
  {
    value: "divorced",
    description: "Divorced",
  },
  {
    value: "widowed",
    description: "Widowed",
  },
];

export const GENDER_OPTIONS = [
  {
    value: "male",
    description: "Male",
  },
  {
    value: "female",
    description: "Female",
  },
];
